<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="font-13">
  2024 &copy; <a class="font-bold" href="https://www.2cs.ch">Consulting, Convergence & System S.A.</a>
</div>

<div class="font-13">
  <a class="px-3" routerLink="/cgv" target="_blank">
    <span i18n="@@cgv">CGV</span>
  </a>
  &nbsp;
  <a class="px-3" routerLink="/cgu" target="_blank">
    <span i18n="@@cgu">CGU</span>
  </a>
  &nbsp;
  <a class="px-3" routerLink="/privacy" target="_blank">
    <span i18n="@@privacyPolicies">Privacy policies</span>
  </a>
</div>
